package com.milta.core.localization.translations.nl

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Laden…",
    errorNoConnection = "Kan de server niet bereiken — controleer je verbinding.",
    errorGeneric = "Er is iets misgegaan. Probeer het later opnieuw.",
    readOnlyNotice = "🔒 Alleen weergave — vanaf dit scherm kan nog geen account worden aangemaakt, gewijzigd of geschorst.",
    kpiAccountsLabel = "Accounts",
    kpiAccountsSubtitle = "alle rollen samen",
    kpiDriversLabel = "Chauffeurs",
    kpiDriversSubtitle = "zonder eigen team",
    kpiPatronsLabel = "Eigenaars",
    kpiPatronsOrgSingular = "organisatie",
    kpiPatronsOrgPlural = "organisaties",
    kpiActiveSubsLabel = "Actieve abonnementen",
    kpiActiveSubsSubtitle = "actief + respijtperiode",
    kpiAtRiskLabel = "Risico",
    kpiAtRiskSubtitle = "proefperiode of verlopen",
    searchPlaceholder = "Zoek op naam, e-mail, organisatie…",
    expandAllAction = "Alles uitvouwen",
    collapseAllAction = "Alles samenvouwen",
    columnAccount = "Account",
    columnContact = "Contact",
    columnType = "Type",
    columnAddedDate = "Toegevoegd / aangemaakt op",
    columnSubscription = "Abonnement",
    columnSince = "Sinds",
    columnRenewal = "Verl.",
    noOrganizationHeader = "Geen organisatie",
    emptySearchResult = "Geen account komt overeen met deze zoekopdracht.",
    patronBadgePrefix = "Eigenaar",
    createdOnPrefix = "Aangemaakt op",
    emptyTeamMessage = "Nog geen chauffeur in dit team.",
    driverBadge = "Chauffeur",
    addedOnPrefix = "Toegevoegd op",
    viaOrganization = "Via organisatie",
    accountCreatedOnUnknown = "Account aangemaakt op —",
    renewalSingular = "verlenging",
    renewalPlural = "verlengingen",
    subscriptionNone = "Geen",
    subscriptionActive = "Actief",
    subscriptionTrial = "Proefperiode",
    subscriptionGrace = "Respijt",
    subscriptionExpiredStatus = "Verlopen",
    subscriptionCancelled = "Geannuleerd",
    planOrganization = "Organisatie",
    planDriver = "Chauffeur",
)
